import React from 'react';

import SingleChoiceBubbleSelect
  from '@components/shared/SingleChoiceBubbleSelect/SingleChoiceBubbleSelect';
import useRoomTypes from '@hooks/Room/useRoomTypes';
import { IRoomType } from '@models/Room/i-room-type';
import styles from './RoomTypes.module.scss';

const getRoomTypesForPackage = (roomTypes: IRoomType[], roomPackageId?: number) => {
  return roomTypes.map(({
    id,
    type,
    logoUrl,
    packages,
  }) => {
    // Don't allow selecting types that aren't compatible with the room package.
    // NOTE: parseInt because `roomPackage` comes from graphql and `id` is always a string.
    const disabled =
      !!(roomPackageId &&
        (!packages || !packages.find((pkg) => Number(pkg.id) === roomPackageId)));

    return {
      id,
      iconUrl: logoUrl,
      title: type,
      disabled,
      tooltipContent: (disabled && `
          Need to change to a kitchen or bathroom room type?
          Please reach out to us at <a href="mailto:hello@havenly.com">hello@havenly.com</a>
        `),
    };
  });
};

interface IRoomTypesProps {
  roomTypeId: number;
  roomPackageId?: number;
  onRoomTypeSelect: (roomType: any) => void;
}
const RoomTypes = ({ roomTypeId, roomPackageId, onRoomTypeSelect }: IRoomTypesProps) => {
  const { roomTypes } = useRoomTypes();
  const packageRoomTypes = getRoomTypesForPackage(roomTypes, roomPackageId);

  const numColumns = Math.ceil(packageRoomTypes.length / 3);

  return (
    <SingleChoiceBubbleSelect
      choices={ packageRoomTypes }
      classes={{
        Ul: `${styles.Ul} ${styles[`Up${numColumns}`]}`,
        Li: styles.Li,
        Button: styles.Button,
        isButtonSelected: styles.isButtonSelected,
        ImagesWrapper: styles.ImagesWrapper,
        SelectedIndicator: styles.SelectedIndicator,
        Title: styles.Title,
      }}
      onChoiceSelect={ (roomType: any) => onRoomTypeSelect(roomType.id) }
      selectedChoiceId={ roomTypeId }
    />
  );
};

export default RoomTypes;
